module.exports = __webpack_public_path__ + "static/media/back-arrow.67c5dc78.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/back-arrow.svg
// module id = 377
// module chunks = 0